import React from 'react';
import './App.css';
import { NavBar } from './components/NavBar';
import SectionSidebar from './components/SectionSidebar';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import ExperienceSection from './components/ExperienceSection';
import ProjectsSection from './components/ProjectsSection';
import Education from './components/education';
import GlobalSuits from './components/GlobalSuits';

function App() {
  return (
    <div className="App poker-theme">
      <GlobalSuits />
      <NavBar />
      <SectionSidebar />

      <Hero />
      <AboutSection />
      <ExperienceSection />
      <ProjectsSection />
      <Education />
    </div>
  );
}

export default App;
